import { Doughnut, mixins } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ["chartData", "options"],
  mixins: [mixins.reactiveProp],
  methods: {
    update() {
      this.$data._chart.update()
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
